import { RadioTower, X } from "lucide-react";
import { Button } from "../components/ui/button";
import { IDS } from "../constants/testIds";
import PTTButton from "./PTTButton";
import { Waveform } from "./Waveform";

export default function BroadcastBar({ channels, contacts, status, onPTTStart, onPTTEnd, onClear, onExit }) {
  const total = channels.length + contacts.length;
  const transmitting = status === "transmitting";
  return (
    <div data-testid={IDS.broadcast.bar} className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[min(960px,calc(100%-2rem))]">
      <div className="rounded-2xl border border-slate-900/10 bg-slate-900 text-white shadow-2xl px-5 py-4 flex items-center gap-5">
        <div className="h-10 w-10 rounded-lg bg-amber-400 text-slate-900 grid place-items-center flex-shrink-0">
          <RadioTower className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="overline !text-amber-300">Group Broadcast</div>
          <div data-testid={IDS.broadcast.count} className="text-sm font-semibold">
            {total === 0 ? "Select channels or units to broadcast" : `Broadcast to ${total} target${total > 1 ? "s" : ""}`}
          </div>
          <div className="text-[11px] text-slate-300 truncate">
            {[...channels.map(c => c.name), ...contacts.map(c => c.name)].join(" · ") || "Tick the checkboxes on channel cards and roster units"}
          </div>
        </div>
        <div className="hidden sm:flex flex-col items-end gap-1">
          <span className="overline !text-slate-300">{transmitting ? "TRANSMITTING" : "STANDBY"}</span>
          <Waveform active={transmitting} color={transmitting ? "text-emerald-400" : "text-slate-600"} />
        </div>
        <PTTButton
          testId={IDS.broadcast.ptt}
          label={`Broadcast to ${total} targets`}
          color="green"
          status={status}
          size="sm"
          disabled={total === 0}
          onPressStart={onPTTStart}
          onPressEnd={onPTTEnd}
        />
        <div className="flex flex-col gap-1">
          <Button data-testid={IDS.broadcast.clear} size="sm" variant="ghost" className="h-7 text-xs text-slate-300 hover:text-white hover:bg-slate-800" onClick={onClear} disabled={total === 0}>Clear</Button>
          <Button data-testid={IDS.broadcast.toggle + "-exit"} size="sm" variant="ghost" className="h-7 text-xs text-slate-300 hover:text-white hover:bg-slate-800" onClick={onExit}><X className="h-3.5 w-3.5 mr-1" />Exit</Button>
        </div>
      </div>
    </div>
  );
}
